export const PACKAGES = [
  {
    tag: "FREE",
    title: "Lab Health Score",
    price: "Free",
    body: "27-question self-assessment across 10 compliance domains. Results: gap report by domain, priority risk ranking, recommended next step. For any CLIA/CAP lab that wants an honest picture of where they stand.",
    cta: "Get My Free Health Score →",
    href: "/health-score",
  },
  {
    tag: "ASSESSMENT",
    title: "Workflow Assessment",
    price: "$1,500 fixed fee",
    body: "Live review of CAPA, deviation, and documentation workflows against CLIA/CAP requirements. Deliverable: written gap analysis, risk-ranked remediation roadmap, one 60-minute debrief call. For labs preparing for accreditation renewal or responding to a recent inspection finding.",
    cta: "Book a Free Compliance Review",
    href: "/validation-intake",
  },
  {
    tag: "PILOT",
    title: "Governed AI Pilot",
    price: "From $3,500",
    body: "Implement 1–2 governed AI-assisted documentation workflows (typically CAPA and deviation management). Every AI-generated draft requires human QA review. Deliverable: configured workflow, controlled document templates, human-review checklist, ALCOA+ audit trail for pilot outputs.",
    cta: "Book a Free Compliance Review",
    href: "/validation-intake",
  },
  {
    tag: "INSPECTION SPRINT",
    title: "Readiness Sprint",
    price: "$4,500–$6,500",
    body: "Defined-scope engagement to prepare for a specific upcoming inspection or accreditation survey. Deliverable: prioritized remediation list, updated/new controlled documents, evidence binder, mock-inspection checklist. For labs with inspection date within 90 days.",
    cta: "Book a Free Compliance Review",
    href: "/validation-intake",
    highlight: true,
  },
  {
    tag: "FRACTIONAL",
    title: "Fractional Support",
    price: "From $1,500/month",
    body: "Ongoing compliance documentation operations for labs without a dedicated QA manager. All tiers include governed AI-assisted drafting, mandatory human review, ALCOA+ audit trail, monthly status report.",
    tiers: [
      { name: "Essentials", price: "$1,500/mo", scope: "1–2 workflows" },
      { name: "Standard", price: "$2,500/mo", scope: "3–5 workflows" },
      { name: "Comprehensive", price: "$4,500/mo", scope: "High-volume/multi-site" },
    ],
    cta: "Book a Free Compliance Review",
    href: "/validation-intake",
  },
];